import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-download",
  "use": "icon-icon-download-usage",
  "viewBox": "0 0 14 17",
  "content": "<symbol viewBox=\"0 0 14 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-download\">\r\n<path d=\"M14 6H10V0H4V6H0L7 13L14 6ZM0 15V17H14V15H0Z\" fill=\"#00A0E9\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol